(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stars-deferred-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stars-deferred-video')) {
    customElements.define('stars-deferred-video', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const button = this.querySelector('button');
        const template = this.querySelector('template');
        if (!button || !template) return;
        this.initialized = true;
        button.addEventListener('click', () => {
          if (this.querySelector('iframe')) return;
          const iframe = template.content.querySelector('iframe')?.cloneNode(true);
          if (!iframe) return;
          button.replaceWith(iframe);
          iframe.focus();
        }, { once: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stars-visual-refinements"] && !Shopify.designMode) return;
  try {
    (() => {
    let generatedId = 0;
    const labelControls = (root = document) => {
      root.querySelectorAll('.hdt-scrollsnap-dot__link:not([aria-label])').forEach((button) => {
        const dots = [...button.parentElement.querySelectorAll('.hdt-scrollsnap-dot__link')];
        button.setAttribute('aria-label', `Go to slide ${dots.indexOf(button) + 1}`);
      });
      root.querySelectorAll('.hdt-slider__button[name="previous"]:not([aria-label])').forEach((button) => {
        button.setAttribute('aria-label', 'Previous slide');
      });
      root.querySelectorAll('.hdt-slider__button[name="next"]:not([aria-label])').forEach((button) => {
        button.setAttribute('aria-label', 'Next slide');
      });
      root.querySelectorAll('a.hdt-full-width-link[data-pr-href]:not([aria-label]):not([aria-labelledby])').forEach((link) => {
        const card = link.closest('.hdt-slider__slide, hdt-card-product, .hdt-card-product');
        const title = card?.querySelector('.hdt-collection-title, .hdt-card-product__title a');
        if (!title) return;
        if (!title.id) title.id = `stars-card-title-${++generatedId}`;
        link.setAttribute('aria-labelledby', title.id);
      });
    };
    const scheduleLabels = (event) => requestAnimationFrame(() => labelControls(event?.target || document));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleLabels, { once: true });
    else scheduleLabels();
    document.addEventListener('init:slide', scheduleLabels);
    document.addEventListener('lazyhtml:added', scheduleLabels);
    document.addEventListener('shopify:section:load', scheduleLabels);
  })();
  } catch(e) { console.error(e); }
})();

})();
